import React from "react";
import {encode as base64_encode} from 'base-64';
import { ReactSession } from 'react-client-session';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from '../App';
import Footer from "../marketplace/Footer";
import {Helpers} from "../config/Helpers";

class Header extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            urlActive: window.location.pathname
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = '/login?redirectUrl=' + base64_encode(window.location.href);
        }
    }

    render() {
        return (
            <>
                <ToastContainer />
                <div className="screen-overlay"></div>

                <div className="loader-wrapper" style={{'display': 'none'}}>
                    <div className="loader"></div>
                </div>

                <aside className="navbar-aside" id="offcanvas_aside">
                    <div className="aside-top">
                        <a href="/" className="brand-wrap">
                            <img src={'/'+Helpers.IMG_LOGO} className="logo" alt="Nest Dashboard"/>
                        </a>
                        <div>
                            <button className="btn btn-icon btn-aside-minimize"><i
                                className="text-muted material-icons md-menu_open"></i></button>
                        </div>
                    </div>
                    <nav>
                        <ul className="menu-aside">
                            <li className={(this.state.urlActive === '/vendor/dashboard' || this.state.urlActive === '/vendor' || this.state.urlActive === '/vendor/') ? 'menu-item active' : 'menu-item'}>
                                <a className="menu-link" href="/vendor/dashboard">
                                    <i className="icon material-icons md-home"></i>
                                    <span className="text">Dashboard</span>
                                </a>
                            </li>
                            <li className={(this.state.urlActive === '/vendor/products') ? 'menu-item active' : 'menu-item'}>
                                <a className="menu-link" href="/vendor/products">
                                    <i className="icon material-icons md-shopping_bag"></i>
                                    <span className="text">Products</span>
                                </a>
                            </li>
                            <li className={(this.state.urlActive === '/vendor/orders') ? 'menu-item active' : 'menu-item'}>
                                <a className="menu-link" href="/vendor/orders">
                                    <i className="icon material-icons md-shopping_cart"></i>
                                    <span className="text">Orders</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </aside>
                <main className="main-wrap">
                    <header className="main-header navbar">
                        <div className="col-search">
                        </div>
                        <div className="col-nav">
                            <button className="btn btn-icon btn-mobile me-auto" data-trigger="#offcanvas_aside"><i
                                className="material-icons md-apps"></i></button>
                            <ul className="nav">
                                <li className="nav-item">
                                    <a className="nav-link btn-icon darkmode" href="#"> <i
                                        className="material-icons md-nights_stay"></i> </a>
                                </li>
                                <li className="dropdown nav-item">
                                    <a className="dropdown-toggle" data-bs-toggle="dropdown" href="#"
                                       id="dropdownAccount" aria-expanded="false"> <img
                                        className="img-xs rounded-circle" src="/assets_admin/imgs/people/avatar-new.png"
                                        alt="User"/></a>
                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownAccount">
                                        <a className="dropdown-item text-danger" href="/"><i
                                            className="material-icons md-exit_to_app"></i>Kembali ke Waroq</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </header>
                    <App/>
                    <Footer/>
                </main>
            </>
        );
    }
}

export default Header;
